import { render, staticRenderFns } from "./InvoiceSectionPanel.vue?vue&type=template&id=18f1255d&scoped=true&"
import script from "./InvoiceSectionPanel.vue?vue&type=script&lang=js&"
export * from "./InvoiceSectionPanel.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceSectionPanel.vue?vue&type=style&index=0&id=18f1255d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f1255d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAutocomplete,VBtn,VCol,VIcon,VRow,VTextField,VTooltip})
